import { render, staticRenderFns } from "./Divider.vue?vue&type=template&id=8c495d40&scoped=true&"
import script from "./Divider.vue?vue&type=script&lang=js&"
export * from "./Divider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c495d40",
  null
  
)

export default component.exports